import React from "react";
import { firestore } from '../../firebase.js';
import ListingItem from '../ListingItem';
import JobModal from '../JobModal';
import '../../Styles/Sass/Listings/listing.sass';

function Posts(props) {
  const [posts, setPosts] = React.useState([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [jobDetail, setJobDetail] = React.useState({});
  const [pageNumber, setPageNumber] = React.useState(1);

  React.useEffect(() => {
    getAllJobs();
    setPageNumber(1);
  }, [props.jobFilter, props.user, props.triggerUpdate]);

  const openModal = async (job) => {
    await setJobDetail(job);
    setIsOpen(true);
  };

  function closeModal() {
    setIsOpen(false);
  };

  const getAllJobs = () => {
    let allJobs = [];
    firestore.collection('jobs').get()
      .then(res => {
        res.forEach(job => {
          if (job.data().takenBy === 'open') {
            allJobs.push(job.data());
          }
        });
        if (props.page === 'findJob') {
          props.jobFilter.areaOfWork.forEach(criteria => {
            allJobs = allJobs.filter(job => {
              return job.areaOfWork.includes(criteria);
            });
          });
          props.jobFilter.requiredServices.forEach(criteria => {
            allJobs = allJobs.filter(job => {
              return job.requiredServices.includes(criteria);
            });
          });
          props.jobFilter.availability.forEach(criteria => {
            allJobs = allJobs.filter(job => {
              return job.availability.includes(criteria);
            });
          });
          if (props.jobFilter.numberOfWorkers !== 0 && props.jobFilter.numberOfWorkers < 5) {
            allJobs = allJobs.filter(job => {
              return job.numberOfCleaners == props.jobFilter.numberOfWorkers;
            });
          } else {
            allJobs = allJobs.filter(job => {
              return job.numberOfCleaners >= props.jobFilter.numberOfWorkers;
            });
          };
          if (props.jobFilter.supplies) {
            allJobs = allJobs.filter(job => {
              return job.suppliesProvided === 'true';
            });
          };
          if (props.jobFilter.equipment) {
            allJobs = allJobs.filter(job => {
              return job.equipmentProvided === 'true';
            });
          };
          if (props.jobFilter.rate < 150) {
            allJobs = allJobs.filter(job => {
              return job.rate <= parseInt(props.jobFilter.rate);
            })
          }
        } else if (props.page === 'profile') {
          allJobs = allJobs.filter(job => {
            console.log(job.postedBy);
            console.log(props.profile);
            return job.postedBy === props.profile;
          });
        };
        setPosts(allJobs);
      })
      .catch(err => {
        console.log(err);
      })
  }

  const renderListings = () => {
    let currentPosts = posts;
    let currentPagePosts = [];
    for (let i = (6 * pageNumber - 6); i < (6 * pageNumber); i++) {
      if (currentPosts[i]) {
        currentPagePosts.push(currentPosts[i]);
      }
    }
    const render = currentPagePosts.map(post => {
      return (
        <ListingItem
          key={post.jobId}
          onClick={() => openModal(post)}
          id={post.jobId}
          headline={post.headline}
          postedByName={post.postedByName}
          postedBy={post.postedBy}
          description={post.description}
          rate={post.rate}
          province={post.province}
          city={post.city}
          postal={post.postal}
        />
      )
    });
    return render;
  };

  return (

    <ul className={ props.page === 'findJob' ? "posts" : 'profilePosts'}>
      <JobModal
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        jobDetail={jobDetail}
        user={props.user}
      />
      <h1 className='posts__title'>{posts.length} Total Listings</h1>
      {renderListings()}
      <div className='posts__pageBox'>
        <button
          className='posts__pageLink posts__pageLink--left'
          onClick={() => setPageNumber(pageNumber - 1)}
          disabled={pageNumber === 1}
        >
          &lt; Prev
        </button>
        <div className='posts__displayPage'>
          Page {pageNumber} of {Math.ceil(posts.length/6)}
        </div>
        <button
          className='posts__pageLink posts__pageLink--right'
          onClick={() => setPageNumber(pageNumber + 1)}
          disabled={pageNumber === Math.ceil(posts.length/6)}
        >
          Next &gt;
        </button>
      </div>
    </ul>
  );
}

export default Posts;